import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';

@Component({
	selector: 'app-inners-social-media-sharing',
	templateUrl: './inners-social-media-sharing.component.html',
	styleUrls: ['./inners-social-media-sharing.component.css']
})
export class InnersSocialMediaSharingComponent implements OnInit {
	@Input()
	public itemUrl: string;
	@Input()
	public text: string;

	constructor(private elementRef: ElementRef) { }

	ngOnInit():void {
		if (!this.itemUrl)
			this.itemUrl = this.elementRef.nativeElement.getAttribute('itemUrl');

		if (!this.text)
			this.text = this.elementRef.nativeElement.getAttribute('text');
	}

}
